export class PendingDeliveryOptions
{
    constructor(
        public title: string,
        public message: string,
        public disableClose: boolean
    )
    {


    }
}